// Ereignisse, die Mach's per Webhook an andere Systeme meldet. Der Server
// leitet sie aus den Sync-Operationen ab (server/src/webhooks.ts); die
// Oberfläche zeigt die Liste zum Auswählen.

export const WEBHOOK_EVENTS = [
  'task.created',
  'task.updated',
  'task.assigned',
  'task.completed',
  'task.reopened',
  'task.deleted',
  'message.created',
  'message.updated',
  'message.deleted',
  'question.asked',
  'question.answered',
  'reaction.added',
  'reaction.removed',
  'media.transcribed',
] as const;

export type WebhookEvent = (typeof WEBHOOK_EVENTS)[number];

export const WEBHOOK_EVENT_LABEL: Record<WebhookEvent, string> = {
  'task.created': 'Aufgabe angelegt',
  'task.updated': 'Aufgabe geändert (Titel, Termin, Priorität, Projekt)',
  'task.assigned': 'Aufgabe zugewiesen',
  'task.completed': 'Aufgabe erledigt',
  'task.reopened': 'Aufgabe wieder geöffnet',
  'task.deleted': 'Aufgabe gelöscht',
  'message.created': 'Neue Nachricht (Text, Sprache, Bild, Video, Datei, Link)',
  'message.updated': 'Nachricht bearbeitet',
  'message.deleted': 'Nachricht gelöscht',
  'question.asked': 'Rückfrage gestellt',
  'question.answered': 'Rückfrage beantwortet (Fragebogen)',
  'reaction.added': 'Reaktion hinzugefügt',
  'reaction.removed': 'Reaktion entfernt',
  'media.transcribed': 'Transkript einer Sprachnachricht oder eines Videos fertig',
};

/** Gruppen für die Auswahl in der Oberfläche */
export const WEBHOOK_EVENT_GROUPS: { label: string; events: WebhookEvent[] }[] = [
  { label: 'Aufgaben', events: ['task.created', 'task.updated', 'task.assigned', 'task.completed', 'task.reopened', 'task.deleted'] },
  { label: 'Nachrichten', events: ['message.created', 'message.updated', 'message.deleted', 'media.transcribed'] },
  { label: 'Rückfragen und Reaktionen', events: ['question.asked', 'question.answered', 'reaction.added', 'reaction.removed'] },
];

export function isWebhookEvent(v: unknown): v is WebhookEvent {
  return typeof v === 'string' && (WEBHOOK_EVENTS as readonly string[]).includes(v);
}
